export const FETCH_TICKETS_REQUEST =
  'inappcards/recentConversations/FETCH_TICKETS_REQUEST'
export const FETCH_TICKETS_RESPONSE =
  'inappcards/recentConversations/FETCH_TICKETS_RESPONSE'
export const FETCH_TICKETS_ERROR =
  'inappcards/recentConversations/FETCH_TICKETS_ERROR'

export const SET_ALL_TICKETS_VISIBILITY =
  'inappcards/recentConversations/SET_ALL_TICKETS_VISIBILITY'
